import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ESTILO_BOTON_LISTAR_NUEVO, ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import ModalConfirmar from "../../../components/modal-confirmar";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
import { disableApplicant, enableApplicant, getListApplicant } from "../../../api/api-applicant";
import { sharedMensajeConfirmacion, sharedNextPage } from "../../../utils/shared-functions";
import { SELECT_HABILITADO_DESHABILITADO } from "../../../utils/const/const-select-habilitado-deshabilitado";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import GridComponent from "../../../components/grid";

import { bindSharedToast, unbindSharedToast, sharedShowToast } from "../../../utils/shared-toast";


// let $ = window.$;
// let DevExpress = window.DevExpress;
// console.log("DevExpress");
// console.log(DevExpress);
// if (DevExpress?.ui?.themes) {
// console.log("DevExpress.ui está disponible");
//   DevExpress.ui.themes.current("light.compact");
// } else {
// console.warn("DevExpress.ui no está disponible");
// }

export default function ListApplicantPage
  () {
  const { t } = useTranslation();

  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  // const [listaElementos, setListaElementos] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);
  const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  const [rowsData, setRowsData] = useState([]);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

  const pageSize = 20;
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const headers = [
    { key: "acciones", title: "ACCIONES" },
    { key: "id", title: "ID", visible: false, },
    { key: "code", title: t('column_code'), visible: true, filter: true, editLabel: false, },
    { key: "name", title: t('column_name'), visible: true, filter: true, editLabel: false, },
    { key: "phoneNumber", title: t('column_phone_number'), visible: true, filter: true, editLabel: false, },
    { key: "emailAddress", title: t('column_email_address'), visible: true, filter: true, editLabel: false, },
    { key: "dateStart", title: t('column_date_start'), visible: true, filter: true, editLabel: false, },
    { key: "expectation", title: t('column_expectation'), visible: true, filter: true, editLabel: false, },
    { key: "enable", title: t('column_enable'), visible: false, filter: true, editLabel: false, },
    { key: "enableLabel", title: t('column_enable_label'), visible: true, filter: true, editLabel: false, },
    { key: "dateProcess", title: t('column_date_process'), visible: true, filter: true, editLabel: false, },
  ];

  useEffect(() => {
    bindSharedToast({
      setMessage: setToastMessage,
      setType: setToastType,
      setVisible: setToastVisible,
    });
    return () => unbindSharedToast();
  }, []);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      let objEnviar = {};
      objEnviar.enable = habilitadoSelected !== null ? habilitadoSelected.value : null;
      objEnviar.paginaInicio = 0; // offset (0-based)
      objEnviar.paginaFin = pageSize;                 // rows per page
      /*let obj = {};
      obj.idMenuPrimerNivel = INT_ID_MODULO_CHECKLIST;
      obj.idMenuSegundoNivel = INT_ID_SEGUNDO_NIVEL_ADMINISTRACION_CHECKLIST;
      obj.idMenuTercerNivel = INT_ID_TERCER_NIVEL_CHECKLIST_OPCIONES_RESPUESTA;
      let obtenerPermisos = await obtenerPermisosPorNivelUsuarioWeb(obj);
      let permiso = obtenerPermisos[0];
      setPermisos(permiso);
      */
      let permiso = null;
      let lista = [];

      lista = await getListApplicant(objEnviar, t);
      // console.log('lista');
      // console.log(lista);
      setRowsData(lista.body);
      agregarAccionesALista(lista.body, permiso);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
    }
  };

  const agregarAccionesALista = (lista, permiso) => {
    try {
      // console.log('agregarAccionesALista');
      // console.log(lista);
      if (lista.length === 0) {
        setRowsData(lista);
      }
      if (lista.length > 0) {
        const objModificar = {
          label: t('btn_modify'),
          color: "green",
          onClick: (param) => modificarElementoSelected(param),
        };
        const objDeshabilitar = {
          label: t('btn_disable'),
          color: "red",
          onClick: (param) => deshabilitarElementoSelected(param),
        };
        const objHabilitar = {
          label: t('btn_enable'),
          color: "green",
          onClick: (param) => habilitarElementoSelected(param),
        };
        for (let i = 0; i < lista.length; i++) {
          const elemento = lista[i];
          let acciones = [];
          acciones.push(objModificar);
          if (elemento.enable === 1) {
            acciones.push(objDeshabilitar);
          }
          if (elemento.enable === 0) {
            acciones.push(objHabilitar);
          }
          lista[i].acciones = acciones;
        }
        setRowsData(lista);
      }
    } catch (err) {
      console.log('agregarAccionesALista err');
      console.log(err);
    }
  }

  const modificarElementoSelected = (data) => {
    try {
      // console.log("modificarElementoSelected");
      // console.log(data);
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      let obj = {};
      obj.titulo = t("label_modify_applicant");
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("applicant", obj, history);
    } catch (err) {
      console.log("modificarElementoSelected err");
      console.log(err);
    }
  };


  const deshabilitarElementoSelected = async (data) => {
    try {
      // console.log("deshabilitarElementoSelected");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("deshabilitarElementoSelected err");
      console.log(err);
    }
  };

  const habilitarElementoSelected = async (data) => {
    try {
      // console.log("habilitarElementoSelected");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarHabilitarVisible(true);
    } catch (err) {
      console.log("habilitarElementoSelected err");
      console.log(err);
    }
  };

  const handleNuevoClick = () => {
    // console.log("handleNuevoClick");
    let obj = {};
    let data = {};
    data.id = 0;
    data.code = "";
    data.name = "";
    data.phoneNumber = "";
    data.emailAddress = "";
    data.dateStart = "";
    data.expectation = "";
    obj.titulo = t("label_crear_applicant");
    obj.params = data;
    sharedNextPage("applicant", obj, history);
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const handleConfirmModalDeshabilitar = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    setProcessingVisible(true);
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      const response = await disableApplicant(objEnviar);
      setProcessingVisible(false);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        sharedShowToast(t("alert_disabled_successfully"), "success", 3000, () => {
          reset();
        });
      }
      if (response.error === true) {
        sharedShowToast(response.message, "error", 3000);
      }
    }
  };

  const handleConfirmHabilitarModal = async () => {
    setModalConfirmarHabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      const response = await enableApplicant(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        sharedShowToast(t("alert_enabled_successfully"), "success", 3000, () => {
          reset();
        });
      }
      if (response.error === true) {
        sharedShowToast(response.message, "error", 3000);
      }
    }
  };

  const getTotalPages = () => {
    if (!totalRows || totalRows <= 0) return 1;
    return Math.ceil(totalRows / pageSize);
  };

  const handlePrevPage = () => {
    if (currentPage <= 1) return;
    const targetPage = currentPage - 1;
    reset(targetPage);
  };

  const handleNextPage = () => {
    const totalPages = getTotalPages();
    if (currentPage >= totalPages) return;
    const targetPage = currentPage + 1;
    reset(targetPage);
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      const totalPages = getTotalPages();
      const safeCurrentPage = currentPage > totalPages ? totalPages : currentPage;
      const startIndex = totalRows > 0 ? (safeCurrentPage - 1) * pageSize + 1 : 0;
      const endIndex = totalRows > 0 ? Math.min(safeCurrentPage * pageSize, totalRows) : 0;
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="flex items-center justify-between py-4">
            <div>
              <div className="flex items-center gap-2">
                {/* <ArrowBack onClick={handleAtrasClick} /> */}
                <h2 className="text-xl font-bold text-gray-900">{t("label_manage_applicant")}</h2>
              </div>
              <p className="text-sm text-gray-500">{t("label_administra_la_lista_de_applicants")}</p>
            </div>
            <div className="flex items-center gap-2">
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_NUEVO}
                onClick={() => {
                  handleNuevoClick();
                }}
              >
                {t("label_nuevo")}
              </button>
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
              <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                {t("label_estado")}
              </label>
              <Select options={SELECT_HABILITADO_DESHABILITADO} isSearchable='true'
                isClearable='true'
                value={habilitadoSelected}
                onChange={(event) => setHabilitadoSelected(event)}
                placeholder={t("placeholder_select_status")}
              />
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
              <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                &nbsp;
              </label>
              <button
                type="button"
                className={ESTILO_BOTON_MODAL_ACEPTAR}
                onClick={() => { reset(); }}
              >
                {t("label_buscar")}
              </button>
            </div>
          </div>
          <br />
          {/* Grid Card */}
          <GridComponent rows={rowsData} headers={headers} />
          <div className="flex items-center justify-between mt-3 text-sm text-gray-600">
            <span>
              {totalRows > 0
                ? `${t('label_showing')} ${startIndex}-${endIndex} ${t('label_of')} ${totalRows} ${t('label_records')}`
                : `${t('label_no_records')}`}
            </span>
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={handlePrevPage}
                disabled={safeCurrentPage <= 1}
                className="px-3 py-1 rounded border border-gray-300 text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
              >
                {t('label_previous')}
              </button>
              <span>
                {t('label_page')} {safeCurrentPage} {t('label_of')} {totalPages}
              </span>
              <button
                type="button"
                onClick={handleNextPage}
                disabled={safeCurrentPage >= totalPages || totalRows === 0}
                className="px-3 py-1 rounded border border-gray-300 text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
              >
                Siguiente
              </button>
            </div>
          </div>
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={() => { setModalConfirmarDeshabilitarVisible(false); }}
            onConfirm={handleConfirmModalDeshabilitar}
            message={sharedMensajeConfirmacion(t("alert_are_you_sure_you_want_to_disable"), elementoSelected?.name)}
          />
          <ModalConfirmar
            isOpen={modalConfirmarHabilitarVisible}
            onCancel={() => { setModalConfirmarHabilitarVisible(false); }}
            onConfirm={handleConfirmHabilitarModal}
            message={sharedMensajeConfirmacion(t("alert_are_you_sure_you_want_to_enable"), elementoSelected?.name)}
          />
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarArea render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
